import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import colors from 'hsl-shared-components/lib/Theme/colors';
import { Trans } from 'react-i18next';
import { formatPrice } from '../../../price';
import {
  getRelativeHeight,
  getRelativeWidth,
} from '../../../components/CardReader/CardReader';

const ValueTicketConfirmation = styled.div`
  position: absolute;
  top: ${getRelativeHeight(76)};
  left: ${getRelativeWidth(13)};
  right: ${getRelativeWidth(13)};
  bottom: ${getRelativeHeight(56)};
  color: ${colors.primary.hslGreyDark};
`;

const ValueTicketTitle = styled.div`
  position: absolute;
  top: -36.5%;
  left: 28.333333%;
  font-weight: 500;
  color: ${colors.primary.hslWhite};
`;

const ValueTicketPassengersAndZone = styled.div`
  position: absolute;
  color: ${colors.primary.hslGreyDark};
  font-size: 1.75em;
  font-weight: 700;
  top: ${getRelativeHeight(50)};
  left: 0;
  right: 0;
  text-align: center;
`;

const Multiplier = styled.span`
  font-size: 0.75em;
  position: relative;
  top: -0.15em;
  font-weight: 100;
`;

const ValueTicketValidity = styled.div`
  position: absolute;
  font-size: 0.85em;
  top: ${getRelativeHeight(135)};
  right: 0;
  left: 0;
  text-align: center;
`;

const ValueTicketPrice = styled.div`
  position: absolute;
  font-size: 0.85em;
  font-weight: 700;
  top: ${getRelativeHeight(218)};
  right: ${getRelativeWidth(107)};
`;

const ValueTicketRemainingFundsTitle = styled.div`
  color: ${colors.primary.hslGreyDark};
  position: absolute;
  font-size: 0.85em;
  font-weight: 300;
  top: ${getRelativeHeight(296)};
  left: ${getRelativeWidth(107)};
`;

const ValueTicketRemainingFunds = styled.div`
  position: absolute;
  font-size: 0.85em;
  font-weight: 700;
  top: ${getRelativeHeight(296)};
  right: ${getRelativeWidth(107)};
`;

const ValueTicketConfirmationScreen = ({
  zones,
  passengers,
  validityEndsAtString,
  price,
  remainingFunds,
}) => (
  <ValueTicketConfirmation>
    <ValueTicketTitle>
      <Trans i18nKey="Generic.singleTicket" />
    </ValueTicketTitle>
    <ValueTicketPassengersAndZone>
      {passengers} <Multiplier>x</Multiplier> {zones}
    </ValueTicketPassengersAndZone>
    <ValueTicketValidity>
      <Trans i18nKey="Generic.validityAbbr" />{' '}
      <strong>{validityEndsAtString}</strong>
    </ValueTicketValidity>
    <ValueTicketPrice>
      <Trans i18nKey="Generic.charged" /> {formatPrice(price * passengers)}
    </ValueTicketPrice>
    <ValueTicketRemainingFundsTitle>
      <Trans i18nKey="Generic.valueRemaining" />
    </ValueTicketRemainingFundsTitle>
    <ValueTicketRemainingFunds>
      {formatPrice(remainingFunds)}
    </ValueTicketRemainingFunds>
  </ValueTicketConfirmation>
);

ValueTicketConfirmationScreen.propTypes = {
  zones: PropTypes.string.isRequired,
  passengers: PropTypes.number.isRequired,
  validityEndsAtString: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  remainingFunds: PropTypes.number.isRequired,
};

export default ValueTicketConfirmationScreen;
